import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {AddTeamMembersSource} from '@Panels/add-team-members-panel/add-team-members-panel.types';
import {authenticateUser, isUserNotLoggedIn} from '@Libraries/user.library';

export const openAddTeamMembersModal = (props: AddTeamMembersSource = {}): void => {
    if (isUserNotLoggedIn()) {
      void authenticateUser(() => {
        openAddTeamMembersModal(props);
      });
      return;
    }
  const modalId = MODALS_IDS.ADD_TEAM_MEMBERS_MODAL;

  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId,
      panelProps: {
        modalId,
        ...props,
      },
    })
  );
};
